import { useState, useEffect } from "react"
import { usePageContext } from "vike-react/usePageContext"
import ContactDialog from "../ContactDialog"
import NavbarDesktop from "./NavbarDesktop"
import NavbarMobile from "./NavbarMobile"
import PubSub from "pubsub-js"

function Navbar() {
  const pageContext = usePageContext()
  const currentPath =
    pageContext?.currentPath ||
    pageContext?.urlPathname ||
    (typeof window !== "undefined" ? window.location.pathname : "/")
  const [contactOpen, setContactOpen] = useState(false)
  const [contactCategory, setContactCategory] = useState("")

  useEffect(() => {
    const token = PubSub.subscribe("open-contacts", (_, data) => {
      setContactCategory(data?.category || "")
      setContactOpen(true)
    })
    return () => PubSub.unsubscribe(token)
  }, [])

  const isCampaignPath = (p) => !!p && (p.startsWith("/c/") || /^\/[a-z]{2}\/c\//.test(p))
  const shouldHide =
    currentPath?.startsWith("/admin") ||
    currentPath?.startsWith("/s/") ||
    currentPath?.startsWith("/r/") ||
    isCampaignPath(currentPath) ||
    (typeof window !== "undefined" &&
      (window.location.pathname.startsWith("/admin") ||
       window.location.pathname.startsWith("/s/") ||
       window.location.pathname.startsWith("/r/") ||
       isCampaignPath(window.location.pathname)))

  if (shouldHide) return null

  return (
    <>
      {/* Desktop: md and above */}
      <div className="hidden lg:block">
        <NavbarDesktop onContactClick={() => setContactOpen(true)} />
      </div>

      {/* Mobile: below md */}
      <div className="lg:hidden">
        <NavbarMobile onContactClick={() => setContactOpen(true)} />
      </div>

      {/* Spacer to push page content below the fixed navbar */}
      <div className="h-16 shrink-0" />

      {contactOpen && <ContactDialog onClose={() => setContactOpen(false)} initialCategory={contactCategory} />}
    </>
  )
}

// AldooComponent definition for auto-discovery
export const AldooComponent = {
  id: "Navbar",
  component: Navbar,
  description:
    "Main navigation bar with logo, nav links via CMS MenuGroup, language selector, and avatar.",
  input: {},
}

export default Navbar